<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" />
    <vis-error size="md" v-else-if="error" with-default :state="state" />
    <div v-else class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start md:ba-mb-8">
      <h4
        class="ba-w-full ba-text-xl md:ba-text-3xl ba-mb-4 xs:ba-mb-6 ba-text-center ba-text-white ba-uppercase"
      >Восстановление доступа <br> к личному кабинету</h4>
      <p v-if="false" class="ba-text-center ba-text-sm ba-mb-4 sm:ba-mb-10">
        <span v-if="settings.adminLogin">для организаций</span>
        <span v-else>для физических лиц</span>
      </p>
      <p class="ba-text-center ba-text-sm ba-mb-4 ba-w-full ba-text-white md:ba-text-xl">
        Пожалуйста, укажите адрес электронной почты.
        <br />На него придет письмо со ссылкой для восстановления пароля.
      </p>
      <form
        @submit.prevent="recoveryFormSubmit"
        class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-max-w-xs ba-relative ba-pt-4"
      >
        <p
          v-if="formError"
          class="error form-message ba-text-center ba-text-sm"
        >Пользователь с таким адресом электронной почты не найден</p>
        <p
          v-if="formSuccess"
          class="success form-message ba-text-center ba-text-sm"
        >Вам на почту отправлено письмо с ссылкой для восстановления пароля.</p>
        <p
          v-if="formFieldsRequired"
          class="error form-message ba-text-center ba-text-sm"
        >Все поля обязательны для заполнения</p>
        <p
          v-if="formInvalidEmail"
          class="error form-message ba-text-center ba-text-sm"
        >Неверный адрес электронной почты</p>
        <vis-form-input
          v-model="form.email"
          :disabled="formLoading"
          label="Email"
          type="text"
          icon="fas fa-envelope"
          autocomplete="off"
        />
        <button
          type="submit"
          :disabled="formLoading"
          class="btn ba-w-full md:ba-w-auto btn--login"
        >Дальше</button>
      </form>
      <router-link
        :to="{ name: 'login', query: { state } }"
        class="forgot ba-block ba-text-center ba-w-full ba-mt-8 ba-underline"
      >
        <span>Вернуться к авторизации</span>
      </router-link>
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import { createSettings } from "@/utils/settings";
import { recoveryMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-page-recovery",
  components: {
    VisLoginLayout
  },
  mixins: [recoveryMixin],
  data() {
    return {
      settings: createSettings()
    };
  },
  watch: {
    recoveryInfo() {
      this.settings = createSettings(this.recoveryInfo?.clientId);
      if (!this.settings.canRemember) {
        this.$router.replace({ name: "login", query: { state: this.state } });
      }
    }
  }
};
</script>
